import React from 'react';
import Button from '../../../../wui-button/src';
export default function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;
  var className = "".concat(prefixCls, "-btn-ok"); // if (okDisabled) {
  //   className += ` ${prefixCls}-ok-btn-disabled`;
  // }

  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    size: "sm",
    colors: "primary",
    disabled: !!okDisabled,
    onClick: okDisabled ? null : onOk
  }, locale.ok);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/calendar/OkButton.js